import { Progress, Upload, message } from 'antd'
import React, { useState } from 'react'

import styled from 'styled-components'

const UPLOAD_URL = 'https://file.wastecambodia.com/upload'

const Preview = styled.img`
  width: 100%;
  height: 100%;
`

const UploadedBox = styled.div`
  width: 100%;
  height: 100%;
`

const DeleteButton = styled.div`
  color: red;
  cursor: pointer;
`

export const ImageUpload = (props) => {
  const { uploadedPhotoUrl } = props
  const [progress, setProgress] = useState(0)
  const [isUploading, setIsUploading] = useState(false)

  function handleChange(info) {
    if (info.file.status === 'uploading') {
      setProgress(info.file.percent)
      setIsUploading(true)
    }

    if (info.file.status === 'done') {
      const fileName = info.file.response
      const uploadedFileUrl = `${UPLOAD_URL}s/${fileName}`
      setIsUploading(false)
      props.onFileUploaded && props.onFileUploaded(uploadedFileUrl)
    }
  }

  function handleDelete(e) {
    e.stopPropagation()
    props.onFileUploaded && props.onFileUploaded()
  }

  return (
    <Upload
      name="avatar"
      multiple={false}
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      action={UPLOAD_URL}
      beforeUpload={beforeUpload}
      onChange={handleChange}
    >
      {isUploading && <Progress percent={progress} showInfo={false} />}
      {!isUploading && uploadedPhotoUrl ? (
        <UploadedBox>
          <Preview src={uploadedPhotoUrl + '?dim=100'} />
          <DeleteButton onClick={handleDelete}>លុប</DeleteButton>
        </UploadedBox>
      ) : (
        <div>ភ្ជាប់រូប</div>
      )}
    </Upload>
  )
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!')
  }
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!')
  }
  return isJpgOrPng && isLt2M
}
